import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../../api/ApiRoutes";
import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import { parseComplianceRules } from "./parseComplianceRule";
import type { ComplianceRule } from "./types";

export const COMPLIANCE_RULES_QUERY_KEY = [
  "regulator-portal",
  "compliance-rules",
] as const;

export const fetchComplianceRules = async (): Promise<ComplianceRule[]> => {
  const response = await createRegulatorPortalInstance().get(
    API_ROUTES.REGULATOR_COMPLIANCE_RULES,
  );
  return parseComplianceRules(response.data);
};

export const useComplianceRules = (
  enabled = true,
): UseQueryResult<ComplianceRule[], Error> =>
  useQuery<ComplianceRule[], Error>({
    queryKey: COMPLIANCE_RULES_QUERY_KEY,
    queryFn: fetchComplianceRules,
    enabled,
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
    retry: false,
  });
